/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".small-card[_ngcontent-%COMP%]{max-width:460px;margin:1rem auto;box-shadow:none;border:1px solid #e8e8e8;border-radius:4px}.padding-top[_ngcontent-%COMP%]{padding-top:65px}"];
export { styles as styles };
